/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1AuditConditions } from '../models/V1AuditConditions';
import { HttpFile } from '../http/http';

export class V1OrderLineAuditConditionsSet {
    'userId'?: string;
    'requestId'?: string;
    'timestamp'?: Date;
    'id'?: string;
    'orgId'?: string;
    'auditConditions'?: V1AuditConditions;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "auditConditions",
            "baseName": "audit_conditions",
            "type": "V1AuditConditions",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineAuditConditionsSet.attributeTypeMap;
    }

    public constructor() {
    }
}

